var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        size: _vm.size,
        loading: _vm.loading,
        placeholder: _vm.placeholder,
        filterable: _vm.filterable,
        clearable: _vm.clearable,
        disabled: _vm.disabled,
        multiple: _vm.multiple
      },
      on: { change: _vm.inputChange },
      model: {
        value: _vm.selected,
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    },
    _vm._l(_vm.options, function(option) {
      return _c("el-option", {
        key: option.id,
        attrs: { value: option.value, label: option.name }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f2f21f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f2f21f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/dictionarySelect/dictionary-select.vue
// module id = null
// module chunks = 